import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_PATH } from '../../constants'
import { http } from '../../utils/config';
import axios from 'axios'

export const refreshToken = createAsyncThunk(
  'auth/refreshToken',
  async () => {
    try {
      const refToken = localStorage.getItem('refreshToken')
      ? localStorage.getItem('refreshToken')
      : null
      const response = await http.post(API_PATH + "/refresh", { refToken });
      console.log("refreshToken: ", refreshToken)

      return response.data
    } catch (error: any) {
      return error.response.data
    }
  }
)

export const userLogin = createAsyncThunk(
    'auth/login',
    async ({ userID, password }: { userID: string, password: string }, { rejectWithValue }) => {
      try {
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
        }
        const { data } = await axios.post(
          `${API_PATH}/login`,
          { userID, password },
          config
        )
        localStorage.setItem('accessToken', data.accessToken)
        localStorage.setItem('refreshToken', data.refreshToken)

        return data
      } catch (error: any) {
        return rejectWithValue(error.response.data)
      }
    }
  )

  export const userLogout = createAsyncThunk(
    'auth/login',
    async () => {
      try {
        
        const response = await http.post(API_PATH + "/logout", {});

        return response.data
      } catch (error: any) {
        return error.response.data
      }
    }
  )

  export const getBackendVersion = createAsyncThunk(
    'auth/version',
    async () => {
      try {

        const response = await fetch(API_PATH + "/version").then(
          (data) => data.json()
        )

        return response.version
      } catch (error: any) {
        return error.response.data
      }
    }
  )
